import { User } from './auth';
import { ProductModel } from './product';
import { ProgramSchedule } from './program-schedule';

export enum IntelligenceType {
  Linguistic = 'linguistic',
  LogicalMathematical = 'logicalMathematical',
  BodilyKinesthetic = 'bodilyKinesthetic',
  Musical = 'musical',
  Spatial = 'spatial',
  Naturalist = 'naturalist',
  Intrapersonal = 'intrapersonal',
  Interpersonal = 'interpersonal',
}
export enum ProgramReportStatus {
  PENDING = 'pending',
  SENT = 'sent',
}

export const INTELLIGENCE_TYPE_LABEL: Record<IntelligenceType, string> = {
  [IntelligenceType.Linguistic]: '언어지능',
  [IntelligenceType.LogicalMathematical]: '논리수학지능',
  [IntelligenceType.BodilyKinesthetic]: '신체운동지능',
  [IntelligenceType.Musical]: '음악지능',
  [IntelligenceType.Spatial]: '공간지능',
  [IntelligenceType.Naturalist]: '자연친화지능',
  [IntelligenceType.Intrapersonal]: '자기성찰지능',
  [IntelligenceType.Interpersonal]: '인간친화지능',
};

interface IntelligenceItem {
  score: number;
  comment?: string;
}

export type Intelligence = Partial<Record<IntelligenceType, IntelligenceItem>>;

export interface ProgramReport {
  _id: string;
  partnerId: string;
  parentId: string;
  instructorId: string;
  scheduleId: string;
  childName?: string;
  productName: string;
  imageUrls?: string[];
  comment: string;
  intelligences: Intelligence;
  isChildOfPartner: boolean;
  status: ProgramReportStatus;
  sentAt?: Date;
  createdAt: Date;
  updatedAt: Date;
  deletedAt?: Date;
}

export interface GetProgramReport extends ProgramReport {
  schedule: ProgramSchedule;
  product: ProductModel;
  partner: User;
  instructor: User;
  parent: User;
}
